/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronsLeft = createReactComponent("chevrons-left", "IconChevronsLeft", [
  ["path", { d: "M11 7l-5 5l5 5", key: "svg-0" }],
  ["path", { d: "M17 7l-5 5l5 5", key: "svg-1" }]
]);

export { IconChevronsLeft as default };
//# sourceMappingURL=IconChevronsLeft.js.map
